import { createStaticReducer } from '../../../../packages/redux-utils';

const defaultState = '';

export const referenceLinkReducer = createStaticReducer<string>(defaultState);
